import tableTap from './table'

export default tableTap